import { createSelector } from 'reselect'

const sortCategoriesByName = (categoryA, categoryB) => {
  return categoryA.value?.name
    ?.replace(/\W+/g, '')
    ?.localeCompare(categoryB.value?.name?.replace(/\W+/g, ''))
}

const getCreatedExpenseCategory = ({ expenseCategory }) => expenseCategory.createdCategory
const getCreatingExpenseCategory = ({ expenseCategory }) => expenseCategory.loading
const getExpenseCategories = ({ expenseCategory }) => expenseCategory.records
const getExpenseCategoryByName = ({ expenseCategory }, name) =>
  expenseCategory.records.find((expenseCategory) => expenseCategory?.value?.name === name)

const mapCategoryFields = (createdCategory) => {
  return createdCategory
}

const expenseCategorySelectors = {
  getCreatedExpenseCategory: createSelector([getCreatedExpenseCategory], (createdCategory) => {
    if (!createdCategory || !Object.keys(createdCategory).length) {
      return {}
    }
    return mapCategoryFields(createdCategory)
  }),
  getCreatingExpenseCategory: createSelector([getCreatingExpenseCategory], (creatingCategory) => {
    return creatingCategory
  }),
  getExpenseCategoryOptions: createSelector([getExpenseCategories], (expenseCategories) => {
    return [...expenseCategories].sort(sortCategoriesByName)
  }),

  getExpenseCategoryByName: createSelector(
    [getExpenseCategoryByName],
    (expenseCategory) => expenseCategory,
  ),
}

export default expenseCategorySelectors
